var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{attrs:{"data":_vm.datas,"highlight-current":true,"expand-on-click-node":false,"check-on-click-node":true,"node-key":"id","props":_vm.defaultProps},on:{"node-click":_vm.nodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[_c('i',{class:data.icon}),_c('span',{staticStyle:{"padding-left":"5px","font-size":"12px"}},[_vm._v(_vm._s(data.label))])])}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e49351","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/Trees.vue
// module id = 20
// module chunks = 0